import {
    Typography,
    useTheme,
    Box,
    useMediaQuery,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import LinkRouter from '../../../components/LinkRouter';
import BreadcrumbsComponent from '../../../components/BreadcrumbsComponent';
import { IBreadcrumb } from '../../../components/BreadcrumbsComponent/types';
import AnnouncementsCarousel from '../Announcements/AnnouncementsCarousel';
import Reporting from '../HomePage/reportingSmall';
import AnnouncementsCarouselTablet from '../Announcements/AnnouncementsCarouselTablet';
import AnnouncementsCarouselPhone from '../Announcements/AnnouncementsCarouselPhone';
import HideForms from '../../../components/SendPulseForms/hide';



// Медіа
const ForMedia = () => {
    const { palette } = useTheme();
    const theme = useTheme();
    const navigate = useNavigate();

    const isXl = useMediaQuery(theme.breakpoints.only("xl"));
    const isLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const isXs = useMediaQuery(theme.breakpoints.down("md"));

    const [breadcrumbs, setBreadcrumbs] = useState<Array<IBreadcrumb>>([
        { name: "Партнерам", urlSlug: "/for-partners" },
        { name: "Медіа", urlSlug: "" },
    ]);

    useEffect(() => {
        document.title = `Медіа`;

    }, [])

    return (
        <>
            <HideForms />
            <Box sx={{ mb: { xs: "43px", lg: "120px" } }}>
                <Box sx={{ my: { xs: "11px", md: "28px", lg: "20px" }, mb: { xs: "28px", md: "0px" } }}>
                    <BreadcrumbsComponent elements={breadcrumbs} />
                </Box>
                <Typography variant="h1" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "26px", lg: "36px" }} lineHeight="38px">
                    Медіа
                </Typography>
                <Typography variant="h5" fontFamily="Fixel Display, sans-serif" fontWeight="600" sx={{ mt: { xs: "14px", lg: "34px" }, mb: { xs: "43px", lg: "100px" } }}>
                    Медіа є нашим важливим партнером у поширенні інформації про події, ініціативи та цінності.. Ми відкриті до співпраці у форматі висвітлення наших заходів, створення спільного контенту чи інформаційної підтримки культурних і освітніх проєктів.
                    <br /><br />
                    Ваша допомога в комунікації дозволить нам донести наші ідеї до ширшої аудиторії, а вам — отримати доступ до унікальних подій, експертів і матеріалів. Ми готові ділитися цікавими історіями, результатами наших проєктів і залучати вас як партнерів у створенні нового, мотивуючого контенту для ваших читачів або глядачів.
                </Typography>
                {/* Анонси */}
                {(isXl || isLg) && <AnnouncementsCarousel />}
                {isMd && <AnnouncementsCarouselTablet />}
                {isXs && <AnnouncementsCarouselPhone />}
                {/* Наша звітність */}
                <Reporting />
            </Box>
        </>
    )
}

export default ForMedia